import { Link } from "react-router";
import { BarChart3, ChevronRight } from "lucide-react";
import PageShell from "../../components/dashboard/PageShell";
import usePermissions from "../../hooks/usePermissions";
import { reportPath, visibleReportGroups } from "../../config/opsReports";

export default function ReportsPage() {
  const { user } = usePermissions();
  const groups = visibleReportGroups(user);

  return (
    <PageShell
      title="Reports"
      description="Role-based operational, recovery, and administration reports."
    >
      {groups.length === 0 ? (
        <div className="rounded-xl border border-primary/[0.07] bg-white px-6 py-12 text-center shadow-sm">
          <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/[0.06] text-primary">
            <BarChart3 className="h-6 w-6" />
          </span>
          <h2 className="text-lg font-bold text-primary">No reports for this role</h2>
          <p className="mx-auto mt-2 max-w-md text-sm text-primary/50">
            Reports appear here for call-centre managers, agents, and super administrators.
          </p>
        </div>
      ) : (
        <div className="space-y-8">
          {groups.map((group) => (
            <section key={group.id}>
              <h2 className="mb-3 text-[11px] font-bold uppercase tracking-[0.14em] text-primary/40">
                {group.label}
              </h2>
              <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
                {group.reports.map((report) => (
                  <Link
                    key={report.slug}
                    to={reportPath(report.slug)}
                    title={report.purpose}
                    className="group rounded-xl border border-primary/[0.07] bg-white p-5 shadow-[0_1px_2px_rgba(127,29,29,0.04)] transition-all hover:border-primary/15 hover:shadow-md"
                  >
                    <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-primary/[0.06] text-primary">
                      <BarChart3 className="h-5 w-5" />
                    </span>
                    <h3 className="text-sm font-bold text-primary group-hover:text-collect">{report.name}</h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-primary/50">{report.purpose}</p>
                    <span className="mt-3 inline-flex items-center gap-1 text-[11px] font-semibold text-collect">
                      Open report
                      <ChevronRight className="h-3.5 w-3.5" />
                    </span>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </PageShell>
  );
}
